// @flow

import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    models: [],
    loading: true,
    error: false,
};

type State = { type?: string };

const AiModels = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'AI_MODELS_LOAD':
            return {...state, loading: true, error: false};

        case 'AI_MODELS_LOADED':
            return {...state, models: action.payload, loading: false, error: false};

        case 'AI_MODELS_REQUEST_FAILED':
            return {...state, loading: false, error: true};

        default:
            return {...state};
    }
};

export default AiModels;
